/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * Personal data delete modal windows constants.
 *
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.17.0
 */

import { IPersonalDataDeleteReducer } from './personalDataDeleteReducer';

export const PERSONAL_DATA_DELETE_START = '@@b2b_portal_ui/personalDataDelete/PERSONAL_DATA_DELETE_START';
export const PERSONAL_DATA_DELETE_SUCCESS = '@@b2b_portal_ui/personalDataDelete/PERSONAL_DATA_DELETE_SUCCESS';

export const initialPersonalDataDeleteState: IPersonalDataDeleteReducer = {
    orderId: '',
};
